import {BASE} from "@/services/Api";
import {TagType} from "@/types/Tag";

export const GetTag = async (
    inputValue: string,
    page = 1,
    showInitialOption = false,
    extraOptions: Record<string, string> = {}
) => {
    // if (!showInitialOption && !inputValue) return [];

    const filters = Object.entries(extraOptions)
        .map(([key, val]) => `&filter_${key}=${val}`)
        .join('');
    const query = `filter_name__contains=${inputValue}${filters}`;

    try {
        const response = await BASE.TAG.list(page, 10, query, "-id");
        const loadOption = response.data.results.map((tag: TagType) => ({
            label: tag.name,
            value: tag.id,
        }));
        return loadOption;
    } catch (e) {
        console.error("Error fetching options:", e);
        return [];
    }
};
